<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">Envoyer un encouragement à <b>{{targetName()}}</b></h2>
  </div>
  <div id="modal-content-wrapper">
    <div class="d-inline-flex w-100">
<!--      <div class="w-50"></div>-->
      <div class="flex-grow-1">
        <form [formGroup]="form" name="send-encouragement-form" (ngSubmit)="sendEncouragement()">
          <div id="message-wrapper" class="form-field required">
            <label>Votre message</label>
            <textarea [class.is-invalid]="messageInvalid" rows="5" maxlength="300"
                      [placeholder]="messagePlaceholder" formControlName="message" type="text" class="form-control"
                      id="message-textarea" aria-describedby="content"></textarea>
            <div class="invalid-feedback">
              Veuillez entrer un message valide.
            </div>
          </div>
          <div id="programed-date-wrapper">
            <div class="form-check form-switch">
              <input class="form-check-input" formControlName="programed" type="checkbox" id="programed-switch">
              <label class="form-check-label" for="programed-switch">Programmer la date et l’heure de ce
                message</label>
            </div>
          </div>
          <div id="programed-date-selector-wrapper" *ngIf="isProgramedEncouragement">
            <div id="date-wrapper">
              <label>Date</label>
              <input id="date-input" formControlName="date" type="text" placeholder="Choisissez une date"
                     class="form-control" [bsConfig]="{ containerClass: 'theme-blue', adaptivePosition: true }"
                     bsDatepicker>
            </div>

            <div id="hour-wrapper">
              <label>Heure</label>
              <input id="hour-input" formControlName="time" type="time" placeholder="Choisissez une heure"
                     class="form-control">
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="right-wrapper">
      <button id="cancel-button" (click)="hideModal()" type="button"
              class="btn btn-outline-primary btn-outline text-only">
        Annuler
      </button>

      <button (click)="sendEncouragement()"
              [disabled]="!isFormValid || isLoading"
              class="btn btn-primary btn-gradient"
              id="validate-button"
              type="submit">
        <ng-container *ngIf="isLoading; else validateButton">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #validateButton>
          Envoyer
          <i i-bs name="envelope" width="20" height="20"></i>
        </ng-template>
      </button>
    </div>
  </div>
</div>
